export default (str) => (str.charAt(0).toUpperCase() + str.slice(1)).trim()
// str
//   .trim()
//   .replace(/\b\w/g, (c) => c.toUpperCase());
